(function($) {
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,

        splitText : {},

        notLoaded : true,

        calloutParallax: function() {
            var inTweens = [];
            var outTweens = [];
            var offsets = [300, 400, 500, 400];

            $('.j-parallax--callouts').each(function() {
                var callouts = $(this);
                var contentTimeline = new TimelineMax();
                var parallaxTimeline = new TimelineMax();
                // __.splitText.callouts_text =  __.global.splitText($('.pg-callouts--text p'));

                callouts.find('.j-parallax--callouts--single').each(function(i) {
                    var _this = $(this);
                    var topShift = offsets[i % 4];
                    var contentTimelineTemp = new TimelineMax();
                    var parallaxTimelineTemp = new TimelineMax();

                    //
                    // parallaxTimelineTemp
                    //     .add( TweenMax.fromTo( _this, 2, {  top: topShift, opacity: (-1 * (i + 2) ) }, { opacity: 6, top: 0, ease: Linear.easeNone } ) )
                    //     .add( TweenMax.fromTo(_this, 0.75, {  top: 0 }, { top: -(topShift), ease: Linear.easeNone }), '+=3' );

                    contentTimelineTemp
                        .add(TweenMax.from(_this.find('.pg-callouts--line'), 0.4, { 'width': 0, ease: Power3.easeOute }))
                        .add(TweenMax.from(_this.find('.pg-callouts--title'), 0.4,  __.global.animations.fade.up ))
                        .add(TweenMax.from(_this.find('.pg-callouts--text'), 0.4,  __.global.animations.fade.up ));

                    contentTimeline.add(contentTimelineTemp, "-=0.7");
                    // parallaxTimeline.add(parallaxTimelineTemp, "0");
                });

                if($('.pg-logo-wall').length > 0) {
                    $('.pg-logo-wall').css({'opacity':1});
                }
                // if (__.global.screen === "large") {
                //     var height = __.window.height();
                //     new ScrollMagic.Scene({ triggerElement: callouts.get(0), duration: height, offset: 200, triggerHook: 1 })
                //         .setTween(parallaxTimeline)
                //         .addTo(__.controller);
                // }

                new ScrollMagic.Scene({ triggerElement: '.pg-callouts--single--inner', duration: 0, offset: 100, triggerHook: 1, reverse: false })
                    .setTween(contentTimeline)
                    .addTo(__.controller);
            });
        },

        carouselAnimation: function() {
            var carousel_container = $('.j-carousel');

            if (__.global.screen === "large") {
                __.splitText.callouts_title =  __.global.splitText($('.pg-carousel--text__desktop p'));
                __.splitText.callouts_title =  __.global.splitText($('.pg-carousel--text__mobile p'));
            }
            var carousel = $('.j-carousel').slick({
                arrows: true,
                dots: false,
                centerMode: true,
                centerPadding: '100px',
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 975,
                        settings: {
                            centerPadding: '50px',
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            centerPadding: '35px',
                        }
                    },
                ]
            });


            if (__.global.screen === "large") {

                carousel.on('onBeforeChange',function(){
                    carousel_container.find('.slick-slide').removeClass('slick-navigation--hovered');
                });
                carousel_container.on('mouseenter','.slick-prev',function(){
                    carousel_container.find('.slick-current').prev().addClass('slick-navigation--hovered');
                }).on('mouseleave','.slick-prev',function(){
                    carousel_container.find('.slick-slide').prev().removeClass('slick-navigation--hovered');
                }).on('mouseenter','.slick-next',function(){
                    carousel_container.find('.slick-current').next().addClass('slick-navigation--hovered');
                }).on('mouseleave','.slick-next',function(){
                    carousel_container.find('.slick-slide').next().removeClass('slick-navigation--hovered');
                });


            }

            new ScrollMagic.Scene({ triggerElement: '.j-carousel', duration: 0, triggerHook: 1, offset: 100, reverse: false })
            .setClassToggle('.j-carousel', 'aos-animate')
            .addTo(__.controller);


            new ScrollMagic.Scene({ triggerElement: '.pg-carousel--content', duration: 0, triggerHook: 1, offset: 150, reverse: false, })
            .setClassToggle('.j-carousel', 'j-carousel--displayed')
            .addTo(__.controller);
        },
        // Animate in the banner section
        homeBanner: function() {
            var timeline = new TimelineMax();

            if (__.global.screen === "large") {



                __.splitText.featured_title =  __.global.splitText($('.pg-home-banner--featured-title'));
                __.splitText.featured_text =  __.global.splitText($('.pg-home-banner--featured-text'));

                timeline
                    .call(function(){
                        __.homeFeatured();
                    })
                    .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), 0 )
                    .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right), '+=1')
                    .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.up), '+=0.4')
                    .add(TweenMax.from('.pg-home-banner--featured', 0.4, __.global.animations.slide.right), '-=0.2');
                    __.global.staggerDisplay( __.splitText.featured_title, timeline);
                    __.global.staggerDisplay( __.splitText.featured_text, timeline);

                timeline.call(function() {
                    __.splitText.featured_title.revert();
                    __.splitText.featured_text.revert();

                });
                timeline
                    .add(TweenMax.from('.pg-home-banner--featured-button', 0.4, __.global.animations.fade.up), '-=0.2')
                    .call(function() { $('.pg-home-banner--featured-button').addClass('aos-animate'); }, null, null, '-=0.2')

                    .add(TweenMax.from('.pg-home-banner--message', 0.4, __.global.animations.slide.right), '-=0.2')

                    .add(TweenMax.from('.pg-home-banner--message-text-inner', 0.4, __.global.animations.fade.right), '-=0.2')
                    .add(TweenMax.from('.pg-banner--scroller', 0.4, { transform: 'translate3d(0, -100px, 0) scale(0)' }), '-=0.2')
                    .call(function() { $('.pg-banner--scroller').addClass('aos-animate'); }, null, null, '-=0.2')
                    .add(TweenMax.from('.pg-header--social', 0.4, __.global.animations.fade.left), '-=0.2')
                    .add(TweenMax.from('.pg-home-content', 0.4, __.global.animations.fade.up), '-=0.2');
            } else {
                timeline
                    .add(TweenMax.from('.pg-header--logo', 0.4, __.global.animations.fade.down), 0 )
                    .add(TweenMax.from('.pg-navigation', 0.4, __.global.animations.slide.right), '+=1')
                    .add(TweenMax.from('.pg-toggle--animation', 0.2, __.global.animations.fade.down), '+=0.4')
                    .add(TweenMax.from('.pg-home-banner--featured', 0.4, __.global.animations.fade.right), '-=0.2');
            }
            timeline.call(function() {
                __.onLoadComplete();
                __.buildScenes();
            });
            timeline.play();
        },

        // Function that runs on load
        homeMessage: function() {

            new ScrollMagic.Scene({
                    duration: $('.j-parallax--message').height(),
                    offset: 0,
                    triggerHook: 1
                })
                .setTween(TweenMax.from('.j-parallax--message', 1, { transform: 'translateX(0%)' }))
                .addTo(__.controller);
        },
        // Function that runs on load
        homeIntroduction: function() {

            __.splitText.intro_title =  __.global.splitText($('.pg-introduction--title'));
            __.splitText.intro_text =  __.global.splitText($('.pg-introduction--text p'));

            var timeline = new TimelineMax();

            __.global.staggerDisplay( __.splitText.intro_title, timeline);
            __.global.staggerDisplay( __.splitText.intro_text, timeline);


            timeline.call(function() {
                __.onLoadComplete();
                __.splitText.intro_title.revert();
                __.splitText.intro_text.revert();
            });
            new ScrollMagic.Scene({
                duration: 0,
                offset: 100,
                triggerHook: 1,
                reverse: false,
                triggerElement: '.pg-introduction--column'
            })
            .setTween( timeline )
            .addTo(__.controller);
        },

        homeFeatured: function() {
            var moveAmount = 0.08;
            var element = $('.j-parallax--featured');

            $('.pg-banner__home').mousemove(function(e) {

                var cursorX = e.pageX;
                var cursorY = e.pageY;
                var halfWindowWidth = (__.window.width() / 2);
                var halfWindowHeight = (__.window.height() / 2);
                var moveX = (cursorX - (halfWindowWidth)) * -moveAmount;
                var moveY = (cursorY - (halfWindowHeight)) * -moveAmount;
                var rotateY = moveX * -0.06;

                var randX = 0.2;
                var randY = 0.2;
                var randZ = 0.3;

                element.each(function() {
                    randX = randX + 0.15;
                    randY = randY + 0.15;
                    randZ = randZ + 0.2;

                    TweenMax.to($(this),
                        1.175, {
                            x: moveX * randX,
                            y: moveY * randY,
                            // rotationY: rotateY * randZ
                        }
                    );
                });
            });
        },

        buildScenes: function() {
            if(__.notLoaded){

                if (__.global.screen === "large") {
                    __.calloutParallax();
                } else {
                }
                __.notLoaded = false;
            }
        },
        // Function that runs on load
        loadAnimations: function() {
            __.homeBanner();
            __.carouselAnimation();
            __.homeIntroduction();
            if (__.global.screen === "large") {
                __.homeMessage();

            }
        },
        // Function that runs on load
        onLoadComplete: function() {
            __.body.addClass('j-animation--complete');
            __.window.trigger('onLoadComplete');
        },
        // Function to call to setup functionality
        setup: function() {
            window._animations.global.setup();
            __.loadAnimations();
        }
    };
    // Attach Toolbox to window //
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.home = __;
})(jQuery); // Fully reference jQuery after this point
